module.exports = __webpack_public_path__ + "static/media/pensioner-0.fa9855c6.png";